var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareSalesReportingAndAnalytics = function SvgYeswareSalesReportingAndAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.357,
    width: 80,
    height: 80,
    rx: 19.422,
    fill: "#E7F1FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.85,
    y: 35.295,
    width: 9.777,
    height: 26.925,
    rx: 4.889,
    fill: "#039BE5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.872,
    y: 16.518,
    width: 9.777,
    height: 45.701,
    rx: 4.889,
    fill: "#039BE5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49.895,
    y: 26.271,
    width: 9.777,
    height: 35.948,
    rx: 4.889,
    fill: "#039BE5"
  })));
};
export default SvgYeswareSalesReportingAndAnalytics;